module.exports = __webpack_public_path__ + "img/icon-youtube.a5cb9822.svg";